import { Link as RouterLink } from 'react-router-dom'
// @mui
import { styled } from '@mui/material/styles'
import { Box, Link, Typography } from '@mui/material'
// hooks
import usePfp from 'src/hooks/usePfp'
// routes
import getTokenName from 'src/utils/getTokenName'
import { PATH_DASHBOARD } from '../../../routes/paths'
// components
// import MyAvatar from '../../../components/MyAvatar'
import PfpPopover from './PfpPopover'
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(2, 2.5),
	borderRadius: Number(theme.shape.borderRadius) * 1.5,
	backgroundColor: theme.palette.grey[500_12],
	transition: theme.transitions.create('opacity', {
		duration: theme.transitions.duration.shorter,
	}),
}))

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined
};

export default function NavbarPfp({ isCollapse }: Props) {
	const { id, tokens } = usePfp()

	const activePfp = tokens.find((token) => token.id === id)

	return (
		// <Link underline="none" color="inherit" component={RouterLink} to={PATH_DASHBOARD.user.account}>
		<RootStyle
			sx={{
				...(isCollapse && {
					bgcolor: 'transparent',
				}),
			}}
		>
			<PfpPopover />

			<Box
				sx={{
					ml: 2,
					transition: (theme) => theme.transitions.create('width', {
						duration: theme.transitions.duration.shorter,
					}),
					...(isCollapse && {
						ml: 0,
						width: 0,
					}),
					overflowX: 'hidden',
				}}
			>
				<Typography variant="subtitle2" noWrap>
					{activePfp && getTokenName(activePfp.tokenId, activePfp._collectionName, activePfp.name)}
				</Typography>
				{/* <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
					{activePfp && getTokenName(activePfp.tokenId, activePfp._collectionName, activePfp.name)}
				</Typography> */}
			</Box>
		</RootStyle>
		// </Link>
	)
}
